import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faSignOutAlt, faChevronRight, faTimes } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { logoutJWT, toggleUserModal } from "../../redux/authJWT/action";
import { defaultLanguage, hasNewCheckout } from "../../helper/utility";
import { language } from "../../languageProvider/language/language";
import { serverResponse } from "../../util/fakeServer";
import "./UserInfo.css";
import { isAppSession } from "../../helper/nativeBridge";

const UserInfoModal = (props) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    props.toggleUserModal();
    props.logoutJWT(navigate);
  };

  const handleGoToProfile = () => {
    props.toggleUserModal();
    navigate("/profilo");
  };

  const {
    authJWT: {
      user: { name, surname, email },
    },
  } = props;

  const initials =
    (name ? name[0] : "").toUpperCase() +
    (surname ? surname[0] : "").toUpperCase();

  return (
    <Modal
      toggle={() => props.toggleUserModal()}
      centered
      isOpen={props.authJWT.modalUserOpen}
      className="userinfo-modal"
    >
      <ModalBody className="userinfo-modal__body">
        {/* Close button */}
        <div
          className="userinfo-modal__close"
          onClick={() => props.toggleUserModal()}
        >
          <FontAwesomeIcon icon={faTimes} />
        </div>

        {/* Avatar + user info */}
        <div className="userinfo-modal__header">
          <div className="userinfo-modal__avatar">{initials}</div>
          <div className="userinfo-modal__info">
            <div className="userinfo-modal__name">
              {name} {surname}
            </div>
            {!serverResponse.config.passwordProtected && (
              <div className="userinfo-modal__email">{email}</div>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="userinfo-modal__actions">
          {/* Area profilo/account: solo stack v2 -> nascosta ai tenant senza
              x_client_token (le pagine ordini/preferiti/premi usano API v2). */}
          {serverResponse.config.allow_login && hasNewCheckout() && (
            <div
              className="userinfo-modal__action"
              onClick={handleGoToProfile}
            >
              <div className="userinfo-modal__action-left">
                <FontAwesomeIcon icon={faUser} className="userinfo-modal__action-icon" />
                <span>{language[defaultLanguage].vai_al_profilo}</span>
              </div>
              <FontAwesomeIcon icon={faChevronRight} className="userinfo-modal__action-chevron" />
            </div>
          )}

          {/* In app il logout si fa dall'app */}
          {!isAppSession() && (
            <div
              className="userinfo-modal__action userinfo-modal__action--danger"
              onClick={handleLogout}
            >
              <div className="userinfo-modal__action-left">
                <FontAwesomeIcon icon={faSignOutAlt} className="userinfo-modal__action-icon" />
                <span>Logout</span>
              </div>
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  authJWT: state.authJWT,
});

export default connect(mapStateToProps, {
  logoutJWT,
  toggleUserModal,
})(UserInfoModal);
